const Register = {
    init() {
        this.handleRegisterType();
    },

    handleRegisterType() {
        const registerSwitchTarget = $('#register-switch-target');

        if (!registerSwitchTarget.length) {
            return;
        }

        $(document).on('change', '#register-switch', function () {
            const target = $(this).data('target');
            const parentTarget = $(target).parents('.register-form__input-group')
                .find('.register-form__input-group-item');

            if ($(this).is(':checked')) {
                $(parentTarget).addClass('is-phone-verify');
            } else {
                $(parentTarget).removeClass('is-phone-verify');
            }

            $(target).find('[name="email"]').val('');
            $(target).find('[name="phone"]').val('');
            $(target).find('[name="phone_display"]').val('');
        });
    }
};

$(document).ready(function () {
    Register.init();
});